import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// Capitalizes the first letter of a string
const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const DynamicBreadcrumbs = () => {
    const location = useLocation();
    const pathNames = location.pathname.split('/').filter(Boolean);

    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 2 }} // Add some margin below
        >
            <Link component={RouterLink} underline="hover" color="inherit" to="/">
                Dashboard
            </Link>
            {pathNames.map((name, index) => {
                const routeTo = `/${pathNames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathNames.length - 1;
                return isLast ? (
                    <Typography color="text.primary" key={routeTo}>
                        {capitalize(name)}
                    </Typography>
                ) : (
                    <Link
                        component={RouterLink}
                        underline="hover"
                        color="inherit"
                        to={routeTo}
                        key={routeTo}
                    >
                        {capitalize(name)}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default DynamicBreadcrumbs;